<template>
  <div class="customFormItem" >
    <span class='label' :style='labelStyle'><em v-if="required">*</em>{{labelText}}</span>
    <div class="formItemContent">
      <el-tabs type="border-card" v-model="activeLang">
        <el-tab-pane label="简体中文" name="zh">
          <div class="input-box">
            <el-input v-model="name.zh_CN" placeholder="请输入中文" @change="change"></el-input>
          </div>
        </el-tab-pane>
        <el-tab-pane label="繁体中文" name="other">
          <el-input v-model="name.zh_HK" placeholder="请输入繁体中文" @change="change"></el-input>
        </el-tab-pane>
        <el-tab-pane label="English" name="en">
          <el-input v-model="name.en" placeholder="Please enter English" @change="change"></el-input>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import { multiInputFormat } from '../utils/global'
import _ from 'lodash'
export default {
  name: 'multiLangInput',
  props: {
    label: String,
    value: Object,
    labelWidth: String,
    required: Boolean
  },
  data () {
    return {
      activeLang: 'zh', // 当前展示的语言
      labelText: this.label || '名称',
      name: _.clone(multiInputFormat)
    }
  },
  mounted () {
    this.name = this.value || _.clone(multiInputFormat)
  },
  computed: {
    labelStyle () {
      const w = this.labelWidth || '100'
      return {
        width: w + 'px'
      }
    }
  },
  watch: {
    value: function (val, oldVal) {
      this.name = val
    },
    label: function (val, oldVal) {
      this.labelText = val
    }
  },
  methods: {
    change: function () {
      console.log('同步多语言文本框')
      this.$emit('input', this.name)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/topdoor/components/multiLangInput.vue